import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { T } from "@/components/T";
import { useLanguage } from "@/contexts/LanguageContext";

export function PartnerSection() {
  const { lang } = useLanguage();
  const stats = lang === "it"
    ? [{ val: "1962", label: "Fondata" }, { val: "3.", label: "Generazione" }, { val: "ISO 9001", label: "Certificato" }, { val: "KlimaHaus", label: "Partner" }]
    : [{ val: "1962", label: "Gegründet" }, { val: "3.", label: "Generation" }, { val: "ISO 9001", label: "Zertifiziert" }, { val: "KlimaHaus", label: "Partner" }];

  const benefits = lang === "it"
    ? ["Pianificazione & Visualizzazione 3D inclusa", "Prefabbricazione per tempi di costruzione più brevi", "Coordinamento & Puntualità come standard", "Assistenza in tedesco e italiano"]
    : ["Planung & 3D-Visualisierung inklusive", "Vorfertigung für kürzere Bauzeiten", "Koordination & Termintreue als Standard", "Betreuung auf Deutsch und Italienisch"];

  return (
    <section data-testid="partner-section" className="section-gap bg-white">
      <div className="container-hb">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4 border-r-0 lg:border-r border-hb-border pr-0 lg:pr-12">
            <span className="label-text block mb-10 reveal"><T de="Unsere Basis" it="La nostra base" /></span>
            <div className="space-y-8">
              {stats.map((s, i) => (
                <div key={i} className={`reveal reveal-delay-${i + 1}`}>
                  <div className="font-bebas text-hb-dark leading-none" style={{ fontSize: "clamp(44px, 5.5vw, 68px)" }}>{s.val}</div>
                  <div className="text-[10px] tracking-widest uppercase font-inter mt-1" style={{ color: "#8a8578" }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="font-bebas text-hb-dark leading-tight mb-6 reveal" style={{ fontSize: "clamp(36px, 4.5vw, 60px)" }}>
              <T de={<>Holzbuddy ist Teil<br /><span className="text-hb-yellow">eines starken Unternehmens.</span></>}
                 it={<>Holzbuddy fa parte<br /><span className="text-hb-yellow">di un'azienda forte.</span></>} />
            </h2>
            <p className="text-base text-hb-text font-inter leading-relaxed mb-10 reveal reveal-delay-1 max-w-lg">
              <T de="Als Holzbaumarke der Hafner EC GmbH haben wir die Ressourcen eines erfahrenen Bauunternehmens im Rücken. Mehr als 60 Jahre Baugeschichte – ISO 9001 zertifiziert, KlimaHaus-Partner der ersten Stunde."
                 it="Come marchio per le costruzioni in legno di Hafner EC GmbH, abbiamo le risorse di un'esperienza costruttiva consolidata. Oltre 60 anni di storia edilizia – certificato ISO 9001, partner KlimaHaus della prima ora." />
            </p>
            <div className="border-t border-hb-border">
              {benefits.map((item, i) => (
                <div key={i} className={`flex items-center gap-4 py-4 border-b border-hb-border reveal reveal-delay-${i + 1}`}>
                  <span className="w-1.5 h-1.5 rounded-full bg-hb-yellow flex-shrink-0" />
                  <span className="text-sm text-hb-text font-inter">{item}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-3 mt-8 reveal">
              <a href="https://www.hafner-ec.com" target="_blank" rel="noopener noreferrer" data-testid="hafner-link" className="btn-secondary flex items-center gap-2">
                Hafner EC GmbH <ArrowUpRight size={11} />
              </a>
              <Link to="/ueber-uns" data-testid="about-team-link" className="btn-secondary">
                <T de="Das Team kennenlernen" it="Conosci il team" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
